<template>
  <div class="tt-franchise">
    <div class="tt-contact-us">
      <div>
        <div class="tt-contact-us__title ff-mont">
          {{ $t('navbar_franchise') }}
        </div>
        <div class="tt-rental-premises__description">
          <div v-html="$t('franchise_description')"></div>
        </div>
        <br /><br />
        <button class="tt-button tt-button--primary" :disabled="loading" @click="linkToFranchising">
          {{ $t('franchise_btn_to_franchising') }}
        </button>

      </div>

      <form class="tt-contact-us__form" v-if="!formSent">
        <div class="tt-input-field">
          <label class="tt-input-field__label">
            {{ $t('franchise_q_name') }}
          </label>
          <input class="tt-input-field__input" :class="{ 'tt-input-field__input--invalid': isInvalid('name') }"
            :placeholder="$t('franchise_fio')" v-model="form.name">
          <div class="tt-input-field__error">
            {{ showError(errors.name) }}
          </div>
        </div>

        <div class="tt-input-field">
          <label class="tt-input-field__label">
            {{ $t('franchise_q_email') }}
          </label>
          <input class="tt-input-field__input" :class="{ 'tt-input-field__input--invalid': isInvalid('email') }"
            :placeholder="$t('about_component_partners_placeholder_email')" v-model="form.email">
          <div class="tt-input-field__error">
            {{ showError(errors.email) }}
          </div>
        </div>

        <div class="tt-input-field">
          <label class="tt-input-field__label">
            {{ $t('franchise_q_phone') }}
          </label>
          <input type="tel" class="tt-input-field__input"
            :class="{ 'tt-input-field__input--invalid': isInvalid('phone') }" v-mask="'+7 (###) ###-##-##'"
            placeholder="+7 (___) ___ __ __" v-model="form.phone">
          <div class="tt-input-field__error">
            {{ showError(errors.phone) }}
          </div>
        </div>

        <div class="tt-input-field" v-for="(item, index) in questionList" :key="item.question.key">
          <label class="tt-input-field__label">
            {{ $t(item.question.key) }}
          </label>
          <div class="tt-v-select" v-if="item.type === 'dropdown'">
            <v-select v-model="item.answer" :clearable="false" :searchable="false"
              :options="localizedOptions[index]" :disabled="!localizedOptions[index].length" label="value"
              :class="{ 'tt-input-field__input--invalid': isAnswerInvalid(index) }" />
          </div>

          <textarea v-else-if="item.type === 'textarea'" :maxlength="item.maxLength" class="tt-input-field__input"
            v-model="item.answer" :class="{ 'tt-input-field__input--invalid': isAnswerInvalid(index) }">
          </textarea>

          <input v-else class="tt-input-field__input" v-model="item.answer"
            :class="{ 'tt-input-field__input--invalid': isAnswerInvalid(index) }">
        </div>

        <button class="tt-button tt-button--primary" :disabled="loading" @click.prevent="submit">
          {{ $t('contacts_widget_btn2send') }}
        </button>
      </form>

      <div class="tt-contact-us__success" v-else>
        <p>{{ $t('contacts_widget_success_message') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { phoneValidator } from "@/mixins/validators";

const YES_NO = [
  { key: 'franchise_opt_yes', ru: 'Да' },
  { key: 'franchise_opt_no', ru: 'Нет' },
];

const CITIES = [
  'Алматы',
  'Астана',
  'Шымкент',
  'Актобе',
  'Караганда',
  'Тараз',
  'Усть-Каменогорск',
  'Павлодар',
  'Атырау',
  'Семей',
  'Кызылорда',
  'Актау',
  'Костанай',
  'Уральск',
  'Туркестан',
  'Петропавловск',
  'Кокшетау',
  'Темиртау',
  'Талдыкорган',
  'Экибастуз',
  'Рудный',
  'Жезказган',
  'Каскелен',
  'Жанаозен',
  'Кентау',
  'Балхаш',
  'Сатпаев',
  'Кульсары',
  'Талгар',
  'Сарыагаш',
  'Конаев',
  'Косшы',
  'Жаркент',
  'Арыс',
  'Аксу',
  'Степногорск',
  'Щучинск',
  'Шу',
  'Жетысай',
  'Риддер',
  'Аягоз',
  'Есик',
  'Шахтинск',
  'Аральск',
  'Аксай',
  'Алтай',
  'Кандыагаш',
  'Житикара',
  'Сарань',
  'Байконур',
  'Ленгер',
  'Шардара',
  'Лисаковск',
  'Атбасар',
  'Текели',
  'Хромтау',
  'Абай',
  'Аркалык',
  'Тобыл',
  'Каратау',
  'Шалкар',
  'Жанатас',
  'Алга',
  'Ушарал',
  'Уштобе',
  'Зайсан',
  'Шемонаиха',
  'Макинск',
  'Сарканд',
  'Акколь',
  'Тайынша',
  'Эмба',
  'Ерейментау',
  'Есиль',
  'Приозёрск',
  'Курчатов',
  'Каркаралинск',
  'Форт-Шевченко',
  'Булаево',
  'Каражал',
  'Сергеевка',
  'Казалинск',
  'Серебрянск',
  'Мамлютка',
  'Державинск',
  'Шар',
  'Степняк',
  'Темир',
  'Жем'
];

export default {
  name: "Franchise",
  data: () => ({
    form: {},
    errors: {},
    loading: false,
    attemptedSubmit: false,
    formSent: false,
    questionList: [
      {
        question: {
          key: 'franchise_q_city',
          ru: 'Ваш город и город открытия'
        },
        answer: '',
        type: 'dropdown',
        options: CITIES,
      },
      {
        question: {
          key: 'franchise_q_residence_time',
          ru: 'Время проживания в данном городе'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_age',
          ru: 'Ваш возраст'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_activity',
          ru: 'Чем занимаетесь на данный момент? (бизнес, инвестиции, наемная работа)'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_business_experience',
          ru: 'Напишите про ваш опыт в бизнесе, если он есть или про опыт в карьере'
        },
        answer: '',
        type: 'textarea',
        maxLength: 500,
      },
      {
        question: {
          key: 'franchise_q_franchise_experience',
          ru: 'Есть ли у Вас опыт работы с франшизой?'
        },
        answer: '',
        type: 'textarea',
        maxLength: 500,
      },
      {
        question: {
          key: 'franchise_q_why_our_franchise',
          ru: 'Почему вас заинтересовала именно наша франшиза?'
        },
        answer: '',
        type: 'textarea',
        maxLength: 500,
      },
      {
        question: {
          key: 'franchise_q_budget',
          ru: 'Каким бюджетом на открытия бизнеса Вы обладаете?'
        },
        answer: '',
        type: 'dropdown',
        options: [
          { key: 'franchise_opt_budget_1', ru: 'менее 20 млн' },
          { key: 'franchise_opt_budget_2', ru: 'между 20 и 30 млн' },
          { key: 'franchise_opt_budget_3', ru: 'между 30 и 50 млн' },
          { key: 'franchise_opt_budget_4', ru: 'между 50 и 100 млн' },
          { key: 'franchise_opt_budget_5', ru: 'между 100 и 120 млн' },
          { key: 'franchise_opt_budget_6', ru: 'более 120 млн' },
        ],
      },
      {
        question: {
          key: 'franchise_q_investment_source',
          ru: 'Источник инвестиции'
        },
        answer: '',
        type: 'dropdown',
        options: [
          { key: 'franchise_opt_inv_own', ru: 'собственные средства' },
          { key: 'franchise_opt_inv_credit', ru: 'кредит' },
          { key: 'franchise_opt_inv_other', ru: 'прочие инвестиции' },
          { key: 'franchise_opt_inv_loan', ru: 'займы' },
        ],
      },
      {
        question: {
          key: 'franchise_q_partners',
          ru: 'Планируете ли Вы привлекать партнеров для открытия филиала?'
        },
        answer: '',
        type: 'dropdown',
        options: YES_NO,
      },
      {
        question: {
          key: 'franchise_q_has_premises',
          ru: 'Имеются ли у Вас коммерческие помещения?'
        },
        answer: '',
        type: 'dropdown',
        options: YES_NO,
      },
      {
        question: {
          key: 'franchise_q_premise_size',
          ru: 'Если имеются коммерческое помещения, то какой площади?'
        },
        answer: '',
        type: 'dropdown',
        options: [
          { key: 'franchise_opt_area_1', ru: 'менее 40 кв.м' },
          { key: 'franchise_opt_area_2', ru: 'между 40 и 90 кв.м' },
          { key: 'franchise_opt_area_3', ru: 'между 90 и 150 кв.м' },
          { key: 'franchise_opt_area_4', ru: 'более 150 кв.м' },
        ],
      },
      {
        question: {
          key: 'franchise_q_ownership',
          ru: 'В собственности у Вас или в аренде?'
        },
        answer: '',
        type: 'dropdown',
        options: [
          { key: 'franchise_opt_own_owned', ru: 'собственное' },
          { key: 'franchise_opt_own_rented', ru: 'арендуемое' },
        ],
      },
      {
        question: {
          key: 'franchise_q_main_or_extra',
          ru: 'Рассматриваете ли Вы этот бизнес как основную сферу деятельности или дополнительную?'
        },
        answer: '',
        type: 'dropdown',
        options: [
          { key: 'franchise_opt_main', ru: 'основная' },
          { key: 'franchise_opt_extra', ru: 'дополнительная' },
        ],
      },
      {
        question: {
          key: 'franchise_q_expected_income',
          ru: 'Уровень дохода, на который планируете выйти по нашей франшизе через год?'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_branches_1year',
          ru: 'Сколько филиалов вы планируете открыть в данном городе в течение 1 года?'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_personal_management',
          ru: 'Намерены ли Вы лично заниматься этим бизнесом? Если нет, то напишите с кем.'
        },
        answer: '',
        type: 'textarea',
        maxLength: 500,
      },
      {
        question: {
          key: 'franchise_q_time_for_management',
          ru: 'Сколько времени вы готовы уделять управлению бизнесом?'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_other_franchises',
          ru: 'Покупку каких альтернативных франшиз Вы рассматривали?'
        },
        answer: '',
      },
      {
        question: {
          key: 'franchise_q_expectations',
          ru: 'Что Вы лично ожидаете получить от сотрудничества?'
        },
        answer: '',
        type: 'textarea',
        maxLength: 500,
      },
      {
        question: {
          key: 'franchise_q_ready_to_start',
          ru: 'В случае одобрения Вашей кандидатуры Управляющей компанией, когда готовы начать открытие нашего филиала?'
        },
        answer: '',
      },
    ],
  }),
  validations() {
    return {
      form: {
        phone: {
          required,
          phoneValidator
        },
        email: {
          required
        },
        name: {
          required
        }
      },
    }
  },
  computed: {
    /** Варианты ответов хранятся с русским значением (уходит в письмо) + ключом перевода для отображения */
    localizedOptions() {
      return this.questionList.map(item => (item.options || []).map(option => (
        typeof option === 'string'
          ? option
          : { ...option, value: this.$t(option.key) }
      )));
    },
  },
  methods: {
    answerToText(item) {
      const answer = item.answer;
      if (answer && typeof answer === 'object') {
        return answer.ru;
      }
      return answer || '';
    },
    linkToFranchising() {
      this.$router.push("/franchising");
    },
    isInvalid(prop) {
      return this.$v.form[prop].$dirty && this.$v.form[prop].$invalid;
    },
    showError(err) {
      return typeof err === 'object' ? err[0] : err;
    },
    isAnswerInvalid(index) {
      const item = this.questionList[index];
      const trimmedAnswer = this.answerToText(item).trim();

      // Если еще не было попытки отправки, то не показываем ошибку.
      // if (!this.attemptedSubmit) {
      //   return false;
      // }
      //
      // if (!trimmedAnswer) {
      //   return true;
      // }
      //
      // if (item.type === 'textarea' && trimmedAnswer.length < 0) {
      //   return true;
      // }
      //
      // return !item.type && trimmedAnswer.length < 0;
    },
    allAnswersValid() {
      return this.questionList.every((item, index) => !this.isAnswerInvalid(index));
    },
    async submit() {
      this.attemptedSubmit = true;
      if (this.$v.form.$invalid || !this.allAnswersValid()) {
        this.$v.form.$touch();
        return;
      }

      this.loading = true;
      let formData = new FormData();

      Object.keys(this.form).forEach(item => {
        formData.append(item, this.form[item]);
      });
      formData.append('type', 'suggestion');

      const message = this.questionList
        .map(item => `<b>${item.question.ru}</b>: <br /> ${this.answerToText(item)}`)
        .join('<br /><br />')
      formData.append('message', message);

      try {
        await this.$axios.post("/feedback", formData);
        this.formSent = true;
      } catch (e) {
        console.error(e.response.data);
        this.errors = (e.response.data || {}).errors;
        if (this.errors.file !== undefined) {
          this.$toast.open({
            position: 'top-right',
            type: 'error',
            message: this.errors.file[0],
            duration: 3000,
          });
        }
      } finally {
        this.loading = false;
      }
    }
  },
  metaInfo() {
    return {
      title: this.$t('franchising_views_meta_title'),
      meta: [{
        vmid: 'description',
        property: 'description',
        content: this.$t('franchising_views_meta_description')
      }, {
        vmid: 'og:title',
        property: 'og:title',
        content: this.$t('franchising_views_meta_og_title')
      }, {
        vmid: 'og:description',
        property: 'og:description',
        content: this.$t('franchising_views_meta_og_description')
      },],
    }
  }
}
</script>

<style scoped lang="sass">
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/vars"
@import "src/assets/styles-new/colors"

.tt-franchise
  padding: 40px 0 100px

.tt-v-select .v-select.tt-input-field__input--invalid
  border-color: red

.tt-v-select .v-select.tt-input-field__input--invalid .vs__selected-options
  border-color: red

.tt-contact-us
  display: flex
  justify-content: space-between
  gap: 32px
  &__title
    font-size: $fs-larger
    line-height: 1.2em
    font-weight: $fw-semibold
    margin-bottom: 24px
  &__subtitle
    margin-bottom: 16px
    font-size: $fs-small
  &__contacts
    display: grid
    grid-template-columns: 100px 1fr
    font-weight: $fw-medium
  &__form
    width: 100%
    max-width: 544px
    .tt-input-field
      margin-bottom: 10px
    .tt-button
      margin-top: 30px
      height: 56px
    .tt-textarea
      height: 140px
  &__success
    margin-top: 8px
    color: $main
    font-weight: $fw-medium

@media screen and (max-width: $tablet-width)
  .tt-contact-us
    &__title
      font-size: $fs-large

@media screen and (max-width: $mobile-width)
  .tt-contact-us
    flex-direction: column
    gap: 0
    &__title
      font-size: $fs-semilarge
      margin-bottom: 16px
    &__contacts
      font-size: $fs-small
      margin-bottom: 40px

</style>
